import { useMemo } from "react";

interface FilePreviewProps {
    file: File;
  }
  export default function FilePreview({ file }: FilePreviewProps) {
    const filePreview = useMemo(() => {
      if (navigator.userAgent.toLowerCase().includes("firefox")) {
        return <p className="text-xs">Your browser does not support PDF previews.</p>;
      }
      return (
        <object
          data={URL.createObjectURL(file)}
          type="application/pdf"
          width="100"
          height="141"
        >
          <p className="text-xs">Your browser does not support PDF previews.</p>
        </object>
      );
    }, [file]);
  
    return (
      <div className="mt-4 p-2 flex justify-center border border-blue-100">
        {filePreview}
      </div>
    );
  }
  